export default "__VITE_ASSET__e93b08e4__"